<template>
  <div v-if="info.content" class="contract-fill-item">
    <div class="contract-title">{{ info.title }}</div>
    <div class="contract-desc" v-html="info.content"></div>
  </div>
</template>

<script>
export default {
  name: "ContractEditDesc",

  props: {
    info: {
      type: Object,
      default: () => ({}),
    },
    isStartGenerate: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    isStartGenerate() {
      // if(this.isStartGenerate) {
      //   this.$nextTick(() => {
      //     const imgEl = document.querySelector('.contract-index-box img')
      //     imgEl.setAttribute('crossOrigin', 'Anonymous')
      //   })
      // } else {
      //   this.$nextTick(() => {
      //     const imgEl = document.querySelector('.contract-index-box img')
      //     imgEl.removeAttribute('crossOrigin')
      //   })
      // }
    },
  },
  mounted() {
    if (this.info.content) {
      this.$nextTick(() => {
        const imgEl = this.$el.querySelectorAll(".contract-index-box img");
        if (imgEl.length > 0) {
          for (let i = 0; i < imgEl.length; i++) {
            imgEl[i].setAttribute("crossOrigin", "Anonymous");
            imgEl[i].setAttribute(
              "src",
              imgEl[i].getAttribute("src") + "?v=" + Date.now()
            );
          }
        }
      });
    }
  },
};
</script>

<style lang="stylus" scoped>
.contract-title {
  padding-top: 28px;
  font-size: 24px;
  font-weight: bold;
}

.contract-desc {
  margin-top: 20px;
  color: #666;
  font-size: 14px;
  line-height: 20px;
  text-align: justify;
  word-break: break-all;

  /deep/ strong {
    color: #000;
    margin: 10px 0;
    display: inline-block;
  }
}

.mobile .contract-desc /deep/ img {
  width: 100%;
}
</style>
